const BASE_CSS_VARS = {
  "theme-website-color-background-primary": "var(--theme-website-color-1)",
  "theme-website-color-background-secondary": "var(--theme-website-color-2)",
  "theme-website-color-border": "var(--theme-website-color-3)",
  "theme-website-color-text-primary": "var(--theme-website-color-4)",
  "theme-website-color-text-secondary": "var(--theme-website-color-5)",
  "theme-website-color-text-link": "var(--theme-website-color-6)",
};

export const BASE_CSS_VARS_LIGHT = {
  ...BASE_CSS_VARS,
  "theme-website-color-text-muted": "#00000088",
  "theme-website-color-border-primary": "#00000044",
  "theme-website-color-border-highlight": "var(--theme-website-color-5)",
};

export const BASE_CSS_VARS_DARK = {
  ...BASE_CSS_VARS,
  "theme-website-color-text-muted": "#FFFFFF88",
  "theme-website-color-border-primary": "#FFFFFF44",
  "theme-website-color-border-highlight": "var(--theme-website-color-5)",
};
